import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import { connect } from "react-redux";
import Visible from "../../../../global/Visible";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class FooterV2 extends Component {
  state = {
    tabWidth: window.innerWidth > 500 ? 125 : window.innerWidth / 4,
    currentTab: 0,
  };
  render() {
    return (
      <>
        <nav
          className="navbar fixed-bottom d-block "
          style={{ maxWidth: "500px", margin: "auto" }}
        >
          <div className="w-100 m-0">
            <div className=" d-flex flex-row w-100">
              <div className="w-25">
                <Link
                  to={
                    this.props.user.role.id === 9 ? `/home` : "/teacherHomeV2"
                  }
                  className={
                    this.state.currentTab === 0
                      ? "text-center py-1 nav-link bottom-nav-link active"
                      : "text-center py-1 nav-link bottom-nav-link"
                  }
                  style={{ width: this.state.tabWidth }}
                  onClick={() => this.setState({ currentTab: 0 })}
                >
                  <i
                    className={
                      this.state.currentTab === 0
                        ? "fa fa-home th-18"
                        : "fa fa-home th-18"
                    }
                    aria-hidden="true"
                  ></i>
                  <div className="th-12">Home</div>
                </Link>
              </div>
              <div className="w-25">
                <Visible roles={["IS_STUDENT"]}>
                  <Link
                    to={"/timetable"}
                    className={
                      this.state.currentTab === 1
                        ? "text-center py-1 nav-link bottom-nav-link active"
                        : "text-center py-1 nav-link bottom-nav-link"
                    }
                    style={{ width: this.state.tabWidth }}
                    onClick={() => this.setState({ currentTab: 1 })}
                  >
                    <i
                      className={
                        this.state.currentTab === 1
                          ? "fa fa-calendar th-18"
                          : "fa fa-calendar th-18"
                      }
                      aria-hidden="true"
                    ></i>
                    <div className="th-12">Timetable</div>
                  </Link>
                </Visible>
              </div>
              <div className="w-25">
                <Visible roles={["IS_TEACHER"]}>
                  <Link
                    to={`/teachertimetable`}
                    className={
                      this.state.currentTab === 2
                        ? "text-center py-1 nav-link bottom-nav-link active"
                        : "text-center py-1 nav-link bottom-nav-link"
                    }
                    style={{ width: this.state.tabWidth }}
                    onClick={() => this.setState({ currentTab: 2 })}
                  >
                    <i
                      className={
                        this.state.currentTab === 2
                          ? "fa fa-calendar th-18"
                          : "fa fa-calendar th-18"
                      }
                      aria-hidden="true"
                    ></i>
                    <div className="th-12">Timetable</div>
                  </Link>
                </Visible>
              </div>
              <div className="w-25">
                <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
                  <Link
                    to={"/birthday"}
                    className={
                      this.state.currentTab === 1
                        ? "text-center py-1 nav-link bottom-nav-link active"
                        : "text-center py-1 nav-link bottom-nav-link"
                    }
                    style={{ width: this.state.tabWidth }}
                    onClick={() => this.setState({ currentTab: 1 })}
                  >
                    <i
                      className={
                        this.state.currentTab === 1
                          ? "fa fa-birthday-cake th-18"
                          : "fa fa-birthday-cake th-18"
                      }
                      aria-hidden="true"
                    ></i>
                    <div className="th-12">Birthday</div>
                  </Link>
                </Visible>
              </div>
              <div className="w-25">
                <Visible roles={["IS_STUDENT"]}>
                  <Link
                    to={"/downloads"}
                    className={
                      this.state.currentTab === 2
                        ? "text-center py-1 nav-link bottom-nav-link active"
                        : "text-center py-1 nav-link bottom-nav-link"
                    }
                    style={{ width: this.state.tabWidth }}
                    onClick={() => this.setState({ currentTab: 2 })}
                  >
                    <i
                      className={
                        this.state.currentTab === 2
                          ? "fa fa-download th-18"
                          : "fa fa-download th-18"
                      }
                      aria-hidden="true"
                    ></i>
                    <div className="th-12">Downloads</div>
                  </Link>
                </Visible>
              </div>
              <div className="w-25">
                <Visible roles={["IS_TEACHER"]}>
                  <Link
                    to={`/tcourses`}
                    className={
                      this.state.currentTab === 1
                        ? "text-center py-1 nav-link bottom-nav-link active"
                        : "text-center py-1 nav-link bottom-nav-link"
                    }
                    style={{ width: this.state.tabWidth }}
                    onClick={() => this.setState({ currentTab: 1 })}
                  >
                    <i
                      className={
                        this.state.currentTab === 1
                          ? "fa fa-book th-18"
                          : "fa fa-book th-18"
                      }
                      aria-hidden="true"
                    ></i>
                    <div className="th-12">Courses</div>
                  </Link>
                </Visible>
              </div>
              {/* <div className="w-25">
                <Visible roles={[ "IS_TEACHER"]}>
                  <Link
                    to={
                      this.props.user.role.id === 9
                        ? `/notifications`
                        : "/tnotifications"
                    }
                    className={
                      this.state.currentTab === 2
                        ? "text-center py-1 nav-link bottom-nav-link active"
                        : "text-center py-1 nav-link bottom-nav-link"
                    }
                    style={{ width: this.state.tabWidth }}
                    onClick={() => this.setState({ currentTab: 2 })}
                  >
                    <i
                      className={
                        this.state.currentTab === 2
                          ? "fa fa-bell-o th-18"
                          : "fa fa-bell-o th-18"
                      }
                      aria-hidden="true"
                    ></i>
                    <div className="th-12">Notifications</div>
                  </Link>
                </Visible>
              </div> */}
              <div className="w-25">
                <Visible roles={["IS_PRINCIPAL"]}>
                  <Link
                    to={"/onlineclass"}
                    className={
                      this.state.currentTab === 2
                        ? "text-center py-1 nav-link bottom-nav-link active"
                        : "text-center py-1 nav-link bottom-nav-link"
                    }
                    style={{ width: this.state.tabWidth }}
                    onClick={() => this.setState({ currentTab: 2 })}
                  >
                    <i
                      className={
                        this.state.currentTab === 2
                          ? "fa fa-desktop th-18"
                          : "fa fa-desktop th-18"
                      }
                      aria-hidden="true"
                    ></i>
                    <div className="th-12">LiveClass</div>
                  </Link>
                </Visible>
              </div>

              <div className="w-25">
                <Visible roles={["IS_ADMIN", "IS_SUPERADMIN"]}>
                  <Link
                    to={"/dashboard"}
                    className={
                      this.state.currentTab === 2
                        ? "text-center py-1 nav-link bottom-nav-link active"
                        : "text-center py-1 nav-link bottom-nav-link"
                    }
                    style={{ width: this.state.tabWidth }}
                    onClick={() => this.setState({ currentTab: 2 })}
                  >
                    <i
                      className={
                        this.state.currentTab === 2
                          ? "fa fa-credit-card th-18"
                          : "fa fa-credit-card th-18"
                      }
                      aria-hidden="true"
                    ></i>
                    <div className="th-12">Accounts</div>
                  </Link>
                </Visible>
              </div>
              <div className="w-25">
                <Link
                  to={
                    this.props.user.role.id === 9
                      ? `/profile`
                      : "/teacherProfile"
                  }
                  className={
                    this.state.currentTab === 3
                      ? "text-center py-1 nav-link bottom-nav-link active"
                      : "text-center py-1 nav-link bottom-nav-link"
                  }
                  style={{ width: this.state.tabWidth }}
                  onClick={() => this.setState({ currentTab: 3 })}
                >
                  <i
                    className={
                      this.state.currentTab === 3
                        ? "fa fa-chevron-up th-18"
                        : "fa fa-chevron-up th-18"
                    }
                    aria-hidden="true"
                  ></i>
                  <div className="th-12">Profile</div>
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </>
    );
  }
}

export default connect(mapStateToProps)(FooterV2);
